<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="菜单名称" prop="name" class="fb-form-item">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>

            <el-form-item label="菜单标识" prop="flag" :error="formErrorMsg.flag" class="fb-form-item">
                <el-input v-model="formData.flag"></el-input>
            </el-form-item>

            <el-form-item label="菜单描述" prop="description" class="fb-form-item">
                <el-input v-model="formData.description"></el-input>
            </el-form-item>

            <el-form-item label="菜单项" prop="description">

                <div class="menu-item-box">

                    <el-tree ref="menuItemTree" class="fb-menu-form-tree" :data="formData.menuItems"
                             :props="defaultProps" @node-click="handleNodeClick"
                             draggable
                    >
                    </el-tree>


                    <div class="menu-item-form">

                        <div class="btn-group">
                            <el-button-group style="display: inline-block">
                                <el-button @click.stop="handleAddBrother" size="small" :disabled="!checkMenuItemData">
                                    新增同级节点
                                </el-button>
                                <el-button @click="handleAddChild" size="small" :disabled="!checkMenuItemData">新增子节点
                                </el-button>
                                <el-button @click="handleDeleteNode" size="small" :disabled="!checkMenuItemData">删除此节点
                                </el-button>
                            </el-button-group>
                        </div>


                        <div class="no-menu-check-form" v-if="!checkMenuItemData">
                            <span>请选中操作节点</span>
                        </div>

                        <el-form v-else label-width="100px" :model="checkMenuItemData" :rules="checkMenuNodeRules"
                                 label-position="top"
                                 style="padding: 20px;">

                            <el-form-item label="菜单名称" class="fb-menu-form-item" prop="name" size="small">
                                <el-input v-model="checkMenuItemData.name"></el-input>
                            </el-form-item>

                            <el-form-item label="菜单链接" class="fb-menu-form-item" prop="url" size="small">
                                <el-input v-model="checkMenuItemData.url"></el-input>
                            </el-form-item>


                            <el-form-item label="菜单icon" class="fb-menu-form-item" prop="icon" size="small">
                                <el-input v-model="checkMenuItemData.icon"></el-input>
                            </el-form-item>

                            <el-form-item label="新窗口打开" class="fb-menu-form-item" prop="newWindows" size="small">
                                <el-select v-model="checkMenuItemData.newWindows">
                                    <el-option label="否" value="0"></el-option>
                                    <el-option label="是" value="1"></el-option>
                                </el-select>
                            </el-form-item>


                            <el-form-item label="自定数据" class="fb-menu-form-item" size="small">
                                <el-input v-model="checkMenuItemData.node"></el-input>
                            </el-form-item>

                        </el-form>

                    </div>


                </div>

            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    export default {
        name: "UserAdd",
        components: {},
        data() {
            return {
                checkMenuItemNode: null,
                checkMenuItemData: null,
                checkMenuNodeRules: {
                    name: [
                        {required: true, message: '请输入菜单名称', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '请输入菜单标识', trigger: 'blur'},
                    ]
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },

                api: {
                    add: this.$api.menu.add
                },
                formErrorMsg: {flag: ''},
                formData: {
                    name: '',
                    flag: '',
                    description: '',
                    menuItems: [{name: '新增菜单', url: '', newWindows: '', icon: ''}],
                },
                rules: {
                    name: [
                        {required: true, message: '请输入菜单名称', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '请输入菜单标识', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            handleAddBrother() {
                let data = {name: '新增菜单', url: '', newWindows: '', icon: ''};
                this.$refs['menuItemTree'].insertAfter(data, this.checkMenuItemNode);
                this.checkMenuItemData = data;
            },
            handleAddChild() {
                let data = {name: '新增菜单', flag: '', url: '', newWindows: '', icon: ''};
                this.$refs['menuItemTree'].append(data, this.checkMenuItemNode);
                this.checkMenuItemData = data;

            },
            handleDeleteNode() {
                this.$refs['menuItemTree'].remove(this.checkMenuItemNode);
            },
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {

                        let formData = JSON.parse(JSON.stringify(this.formData));

                        let fillSortNum = function(menuItems){
                            menuItems.forEach((e, i) => {
                                e.sortNum = i + 1;
                                if(e.children){
                                    fillSortNum(e.children);
                                }
                            });
                        };

                        fillSortNum(formData.menuItems);



                        vm.$http.post(vm.api.add, formData).then((resp) => {

                            if (resp.data.status === 200) {
                                vm.$message({
                                    type: 'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            } else if (resp.data.status === 400) {

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if (resp.data.desc) {
                                    vm.$message({
                                        type: "error",
                                        message: resp.data.desc
                                    });
                                }


                            } else {
                                vm.$message({
                                    type: "error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            },
            handleNodeClick() {
                this.checkMenuItemData = arguments[0];
                this.checkMenuItemNode = arguments[1];
                return false;
            }
        },
        created() {
            let vm = this;

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

    .menu-item-box {
        width: 680px;
        height: 100%;
        border: 1px solid #dcdfe6;
        overflow: hidden;
        position: relative;
    }

    .menu-item-form {
        width: 529px;
        display: inline-block;
        float: left;
        border-left: 1px solid #dcdfe6;
    }

    .btn-group {
        border-bottom: 1px solid #dcdfe6;
        padding: 10px;
        text-align: right
    }

    .no-menu-check-form {
        min-height: 300px;
        text-align: center;
        line-height: 300px;
    }

    .fb-menu-form-tree {
        min-width: 150px;
        height: 100%;
        display: inline-block;
        float: left;
    }

</style>

<style lang="scss">


    .fb-menu-form-tree {
        .el-tree-node__label {
            padding-right: 20px;
        }
    }

</style>